import { canWithScope } from '@/src/access/access-helpers';
import type { AccessContext } from '@/src/access/access-types';

export const voicePermissionKeys = [
  'contact_center.voice.view',
  'contact_center.voice.call',
  'contact_center.voice.post_call',
  'contact_center.voice.manage_lists',
  'contact_center.voice.manage_policy',
  'contact_center.voice.view_artifacts',
  'contact_center.voice.view_reports',
] as const;

export function canUseVoiceWorkspace(access: AccessContext | null | undefined) {
  return voicePermissionKeys.some((permission) => canWithScope(access, permission, 'OWNED'));
}

export function canUseVoiceRuntime(access: AccessContext | null | undefined) {
  return [
    'contact_center.voice.view',
    'contact_center.voice.call',
    'contact_center.voice.post_call',
  ].some((permission) => canWithScope(access, permission, 'OWNED'));
}
